export default __webpack_public_path__ + "static/media/raya-bg-mobile.d912290d.png";